import { h, defineComponent } from 'vue';
import { container } from '@/ui/components';
import BillingDetails from '@/_legacy/views/Subscriptions/BillingDetails.vue';

export const BillingDetailsPage = defineComponent({
  name: 'BillingDetailsPage',
  setup() {
    return function render() {
      return container(
        [
          container([
            // @ts-ignore
            h(BillingDetails, { class: 'legacy' }),
          ], 'medium'),
        ],
      );
    };
  },
});
